module.exports = __webpack_public_path__ + "img/smanga-logo.6c167416.png";